export enum Environment {
    Local = 'local',
    Dev = 'dev',
    Qa = 'qa',
    Prod = 'prod'
}

export enum EnvironmentIndicator {
    local = 'localhost',
    dev = 'dev.',
    qa = 'qa.',
}